<template>
    <div>
      <vue-headful
      title="Dashboard | Create Business Card"
      description="Dashboard | Create Business Card"
  />
  
      <div>
          <nav style="position: fixed;width: 100%;height: 71px;background: #ffffff;border-bottom: 1px solid #dde1ed;z-index: 99;">
              <div style="display: flex;align-items: center;height: 100%;justify-content: space-between;margin-left: 20px;margin-right: 20px;">
                  <button @click="back" class="btn btn-light"><i class="fa-solid fa-chevron-left mr-2"></i> Back</button>
              </div>
          </nav>
  
  
  
  
  
          <div v-if="loading_logos" style="margin: 0 auto;" class="pt-7">
            <center>
                <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
                <p class="lead">Loading...</p>
            </center>
          </div>
          <div v-else class="container">
            <div v-if="step === '1'" class="pt-7">
                <progress value="1" max="3" class="w-100 mb-3">Step 1 of 3</progress>
                <h1>Select your brand</h1>
                <p class="lead">Select the brand you want to use for your Business Card.</p>
                <div v-if="logos !== null && logos.length > 0" class="row">
                    <div v-for="(logo, index) in logos" class="col-6 col-md-4 col-lg-3">
                        <div @click="choose_logo(logo.unique_id, logo.paid_svglogos_s3);" class="aumentarscale_btn" :class="{ 'selectedcontainer': logo_unique_id === logo.unique_id }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #FFFFFF;">
                            <div v-if="logo.paid_svglogos_s3 === 'needs_update'" class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                                <img :src="'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+timenow" style="width: 100%; border-radius: 5px;height: auto;">
                            </div>
                            <div v-else class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                                <img :src="'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+timenow" style="width: 100%; border-radius: 5px;height: auto;">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                <p class="lead">No logos created in this account.</p>
                    <a href="/create/" class="btn btn-primary"><svg width="20" height="20" viewBox="0 0 20 20" fill="#fff" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-jhaWeW kclIni"><path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5z"></path></svg>
                    Create Logos Now</a>
                </div>
            </div>
            <div v-if="step === '2'" class="pt-7">
                <progress value="2" max="3" class="w-100 mb-3">Step 2 of 3</progress>
                <h1>Pick a template</h1>
                <p class="lead">Select a professional template. You can always customize it later.</p>
                <div class="row" style="justify-content: center;">
                    <div class="col-12 col-lg-4 col-md-6">
                        <div @click="choose_template('1');" class="aumentarscale_btn" :class="{ 'selectedcontainer': template === '1' }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #FFFFFF;">
                            <div class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;justify-content: center;align-items: center;">
                                <div v-if="creating_business_card && template === '1'" class="spinner-border text-gray" role="status" style="position: absolute;top: 65px;left: 43%;width: 3rem;height: 3rem;">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                    <!-- Background -->
                                    <rect x="222" y="0" width="278" height="250" fill="white"></rect>
                                    <rect x="0" y="0" width="222" height="250" fill="white"></rect>

                                    <!-- Logo -->
                                    <defs>
                                        <clipPath id="roundedClip">
                                        <rect x="16" y="30" width="190" height="190" rx="5" ry="5"></rect>
                                        </clipPath>
                                    </defs>

                                    <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip)"></image>
                                    <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="190" width="190" y="30" x="16" clip-path="url(#roundedClip)"></image>

                                    <!-- Text elements -->
                                    <g transform="translate(0, 56.75)">
                                        <text x="235" y="0" font-family="Arial" font-size="24" fill="#000000">John Doe</text>
                                        <text x="235" y="30" font-family="Arial" font-size="18" fill="#000000">CEO</text>
                                        <text x="235" y="80" font-family="Arial" font-size="14" fill="#000000">555 555-5555</text>
                                        <text x="235" y="105" font-family="Arial" font-size="14" fill="#000000">hello@website.com</text>
                                        <text x="235" y="130" font-family="Arial" font-size="14" fill="#3f83f8">www.mybrand.com</text>
                                        <text x="235" y="155" font-family="Arial" font-size="14" fill="#000000">123 Main Street Los Angeles</text>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 col-md-6">
                        <div @click="choose_template('2');" class="aumentarscale_btn" :class="{ 'selectedcontainer': template === '2' }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #FFFFFF;">
                            <div class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;justify-content: center;align-items: center;">
                                <div v-if="creating_business_card && template === '2'" class="spinner-border text-gray" role="status" style="position: absolute;top: 65px;left: 43%;width: 3rem;height: 3rem;">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                    <!-- Background -->
                                    <rect x="0" y="0" width="500" height="250" fill="white"></rect>

                                    <!-- Logo on the Right Side -->
                                    <!-- Define the circle clip path -->
                                    <defs>
                                        <clipPath id="circleClip2">
                                        <ellipse cx="400" cy="125" rx="73.5" ry="73.5"/>
                                        </clipPath>
                                    </defs>

                                    <!-- Image with the circular clip path -->
                                    <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip2)"></image>
                                    <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="147" width="147" y="51.5" x="326.5" clip-path="url(#circleClip2)"></image>

                                    <!-- Text elements -->
                                    <g transform="translate(0, 56.75)">
                                        <text x="30" y="0" font-family="Arial" font-size="24" fill="#000000">John Doe</text>
                                        <text x="30" y="30" font-family="Arial" font-size="18" fill="#000000">CEO</text>
                                        <text x="30" y="80" font-family="Arial" font-size="14" fill="#000000">555 555-5555</text>
                                        <text x="30" y="105" font-family="Arial" font-size="14" fill="#000000">hello@website.com</text>
                                        <text x="30" y="130" font-family="Arial" font-size="14" fill="#3f83f8">www.mybrand.com</text>
                                        <text x="30" y="155" font-family="Arial" font-size="14" fill="#000000">123 Main Street Los Angeles</text>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4 col-md-6">
                        <div @click="choose_template('3');" class="aumentarscale_btn" :class="{ 'selectedcontainer': template === '3' }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #FFFFFF;">
                            <div class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;justify-content: center;align-items: center;">
                                <div v-if="creating_business_card && template === '3'" class="spinner-border text-gray" role="status" style="position: absolute;top: 65px;left: 43%;width: 3rem;height: 3rem;">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <svg xmlns="http://www.w3.org/2000/svg" class="svg-card" preserveAspectRatio="xMidYMid meet" viewBox="0 0 500 250">
                                    <!-- Background -->
                                    <rect x="0" y="0" width="500" height="250" fill="white"></rect>

                                    <g transform="translate(470, 0) rotate(90)">
                                        <!-- Logo on the Top Left Side -->
                                        <!-- Define the circle clip path -->
                                        <defs>
                                            <clipPath id="circleClip3">
                                            <ellipse cx="125" cy="100" rx="70" ry="70"/>
                                            </clipPath>
                                        </defs>

                                        <!-- Apply the circle clip path to the logo image -->
                                        <image v-if="paid_svglogos_s3 === 'needs_update'" :href="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip3)"></image>
                                        <image v-else :href="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" height="140" width="140" y="30" x="55" clip-path="url(#circleClip3)"></image>

                                        <!-- Text elements -->
                                        <g transform="translate(0, 240)">
                                            <text x="125" y="0" font-family="Cursive" font-size="24" fill="#000000" text-anchor="middle">John Doe</text>
                                            <text x="125" y="30" font-family="Arial" font-size="18" fill="#000000" text-anchor="middle">CEO</text>
                                            <text x="125" y="80" font-family="Arial" font-size="14" fill="#000000" text-anchor="middle">555 555-5555</text>
                                            <text x="125" y="105" font-family="Arial" font-size="14" fill="#000000" text-anchor="middle">hello@website.com</text>
                                            <text x="125" y="130" font-family="Arial" font-size="14" fill="#3f83f8" text-anchor="middle">www.mybrand.com</text>
                                            <text x="125" y="155" font-family="Arial" font-size="14" fill="#000000" text-anchor="middle">123 Main Street Los Angeles</text>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
  
  
  


  
  
  
  
      
    </div>
  
    </div>
  
  </template>
  
    <script>
    import ClickOutside from 'vue-click-outside';

    export default {
      props:['propsdata'],
      data() {
        return {
          loading_logos: true,
          timenow: Date.now(),
          step: '1',
          logos: [],
          logo_unique_id: '',
          logo_paid_svglogos_s3: '',
          template: '',
          creating_business_card: false,
          retry_axios: 1
        };
      },
      methods: {
        async load_logos(){
            // Wait until propsdata paid is populated
            while (this.propsdata[0].paid === '') {
                // Wait for 100ms before checking again
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            if(this.propsdata[0].paid === 'yes'){
                axios.post('/dashboard/cargar-logos-unique-id.php', {
                })
                .then(response => {
                    this.logos = response.data;
                    this.loading_logos = false;
                })
                .catch(function (error) {
                console.log(error);
                });
            }
            else{
                this.$router.push('/dashboard/business-cards'); //redirect to business cards
            }
        },
        back(){
            if(this.step === '1'){
                this.$router.push('/dashboard/business-cards'); //redirect to business cards
            }
            else if(this.step === '2'){
                this.step = '1';
            }
        },
        choose_logo(unique_id, paid_svglogos_s3){
            this.logo_unique_id = unique_id;
            this.logo_paid_svglogos_s3 = paid_svglogos_s3;
            this.step = '2';
        },
        choose_template(num){
            if(!this.creating_business_card){
                this.creating_business_card = true;
                this.template = num;
                this.save_business_card();
            }
        },
        save_business_card(){
            axios.post('/dashboard/save-business-card.php', {
                logo_unique_id: this.logo_unique_id,
                template: this.template,
                name: 'John Doe',
                role: 'CEO',
                email: 'hello@website.com',
                phone: '555 555-5555',
                website: 'www.mybrand.com',
                address: '123 Main Street Los Angeles',
                background_color: '#ffffff',
                name_color: '#000000',
                role_color: '#000000',
                phone_color: '#000000',
                email_color: '#000000',
                website_color: '#3f83f8',
                address_color: '#000000'
            })
            .then(response => {
                if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
                    this.retry_axios = this.retry_axios+1;
                    this.save_business_card();
                }
                else{
                    this.$router.push('/dashboard/edit-business-card/'+response.data); //redirect to business card editor
                    this.retry_axios = 1;
                    this.creating_business_card = false;
                }
            })
            .catch(function (error) {
            console.log(error);
            });
        }
      },
      mounted() {
        this.$emit('updateprops');
        this.load_logos();
      },
    // do not forget this section
    directives: {
    ClickOutside
    }
    };
    </script>
  


// WEBPACK FOOTER //
// src/create-business-card.vue